export default __webpack_public_path__ + "static/media/03-rock-sx.cc6c3fb8.gif";